export const HTTP = 'Action.Http';
export const HTTP_POST = 'HttpPOST';
export const TOGGLE_VISIBILITY = 'Action.ToggleVisibility';
export const SUBMIT = 'Action.Submit';
